/* AthleteSwap Verkaufen — geführter Ankauf-Assistent.
   Vanilla-JS-Widget nach dem Muster von assets/as-fit-tool.js (Re-Render
   bei jedem Zustandswechsel, kein Framework). Braucht as-verkaufen-daten.js
   vorher geladen.

   DATENMODELL: Eine Liste EINZELNER Artikel (this.artikel), nicht eine
   Sammlung pro Kategorie. Wer "3 Paar Schlittschuhe" wählt, bekommt drei
   eigenständige Datensätze mit je eigener Marke, Größe, Zustand und je
   eigenen Fotos — jeder Artikel wird einzeln erfasst, einzeln bebildert und
   einzeln übermittelt. (Die frühere Fassung speicherte pro Kategorie nur
   EINEN Datensatz und nutzte die Menge lediglich als Zahl im Text; Fotos
   mehrerer Paare landeten dadurch in einem gemeinsamen Topf.)

   ÜBERMITTLUNG: Der Kunde schickt uns am Ende selbst eine Mail aus seinem
   eigenen Postfach — mit fertigem Text und allen Fotos als EINER
   Zip-Datei im Anhang. Er gibt deshalb bewusst keine E-Mail-Adresse mehr
   ein: Wir haben sie automatisch als Absender und antworten einfach darauf.

   Kein Shopify-Kontaktformular mehr. Shopifys `form 'contact'` kann keine
   Anhänge empfangen, verlangt aber zwingend ein E-Mail-Feld — beides passt
   nicht mehr zu diesem Ablauf.

   Warum der Teilen-Dialog und kein reiner Mailto-Link: `mailto:` kann
   prinzipbedingt KEINE Dateien anhängen; sonst könnte jede Website
   ungefragt Dateien vom Gerät verschicken. Der native Teilen-Dialog kann
   es — dort öffnet sich die Mail-App mit angehängter Zip-Datei und
   vorbereitetem Text (Handy). Fehlt er, wird die Zip-Datei heruntergeladen
   UND die Mail mit fertigem Text geöffnet; dann bleibt nur das Anhängen
   der einen Datei von Hand.

   Fotos werden beim Auswählen verkleinert (siehe bildVerkleinern) und beim
   Absenden ohne Fremdbibliothek zu einer Zip-Datei gepackt (siehe
   zipBauen). Da die Seite nicht mehr neu lädt, bleiben sie durchgehend im
   Arbeitsspeicher — eine Zwischenspeicherung ist nicht nötig. */
(function () {
  var PROFIL_SCHLUESSEL = "as_verkaufen_v2";
  var JA_NEIN_LABELS = { ja: "Ja", nein: "Nein", unsicher: "Weiß ich nicht" };
  var MAX_MENGE = 10;

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function daten() {
    return window.AsVerkaufenDaten;
  }

  /* Fragen antworten standardmässig mit Ja/Nein/Weiß ich nicht. Eine Frage
     kann stattdessen eigene "optionen" mitbringen (z. B. wie fest die Ferse
     ist) oder mit typ "text" eine freiwillige Freitextantwort erlauben. */
  function frageOptionen(frage) {
    if (frage.optionen) return frage.optionen;
    return [
      { wert: "ja", label: JA_NEIN_LABELS.ja },
      { wert: "nein", label: JA_NEIN_LABELS.nein },
      { wert: "unsicher", label: JA_NEIN_LABELS.unsicher }
    ];
  }

  function antwortLabel(frage, wert) {
    if (!wert) return "";
    if (frage.typ === "text") return wert;
    var treffer = frageOptionen(frage).filter(function (o) { return o.wert === wert; })[0];
    return treffer ? treffer.label : wert;
  }

  function istPflichtfrage(frage) {
    return frage.typ !== "text";
  }

  function profilLesen() {
    try {
      var roh = window.localStorage.getItem(PROFIL_SCHLUESSEL);
      if (!roh) return null;
      return JSON.parse(roh);
    } catch (e) {
      return null;
    }
  }

  function profilSchreiben(zustand) {
    try {
      /* Fotos sind File-Objekte und lassen sich nicht serialisieren — sie
         werden bewusst nicht gespeichert. Alles andere überlebt einen
         Reload, damit niemand seine Eingaben doppelt machen muss. */
      var artikelOhneFotos = zustand.artikel.map(function (a) {
        return {
          uid: a.uid,
          kategorie: a.kategorie,
          marke: a.marke,
          modell: a.modell,
          modellUnbekannt: a.modellUnbekannt,
          groesse: a.groesse,
          groesseUnbekannt: a.groesseUnbekannt,
          antworten: a.antworten,
          notiz: a.notiz
        };
      });
      window.localStorage.setItem(
        PROFIL_SCHLUESSEL,
        JSON.stringify({ artikel: artikelOhneFotos })
      );
    } catch (e) {
      /* Speicher voll oder gesperrt — der Assistent funktioniert dann nur für diesen Aufruf. */
    }
  }

  function AsVerkaufenWizard(root) {
    this.root = root;
    this.artikel = [];
    this.aktuellerIndex = 0;
    this.schritt = "kategorien";
    this.ausZusammenfassung = false;
    this.fehler = {};
    this.uidZaehler = 0;

    var profil = profilLesen();
    if (profil && profil.artikel && profil.artikel.length > 0) {
      var self = this;
      this.artikel = profil.artikel.map(function (a) {
        self.uidZaehler += 1;
        return {
          uid: a.uid || "a" + self.uidZaehler,
          kategorie: a.kategorie,
          marke: a.marke || "",
          modell: a.modell || "",
          modellUnbekannt: !!a.modellUnbekannt,
          groesse: a.groesse || "",
          groesseUnbekannt: !!a.groesseUnbekannt,
          antworten: a.antworten || {},
          notiz: a.notiz || "",
          fotos: {}
        };
      }).filter(function (a) {
        return !!daten().kategorieFinden(a.kategorie);
      });
    }

    this.render();
  }

  AsVerkaufenWizard.prototype.speichern = function () {
    profilSchreiben(this);
  };

  /* ---------- Artikel-Datenmodell ---------- */

  AsVerkaufenWizard.prototype.neuerArtikel = function (kategorieId) {
    this.uidZaehler += 1;
    return {
      uid: "a" + this.uidZaehler + "-" + Date.now(),
      kategorie: kategorieId,
      marke: "",
      modell: "",
      modellUnbekannt: false,
      groesse: "",
      groesseUnbekannt: false,
      antworten: {},
      notiz: "",
      fotos: {}
    };
  };

  AsVerkaufenWizard.prototype.artikelDerKategorie = function (kategorieId) {
    return this.artikel.filter(function (a) {
      return a.kategorie === kategorieId;
    });
  };

  /* Setzt die Stückzahl einer Kategorie und legt dabei ECHTE einzelne
     Artikel an bzw. entfernt sie. Neue Artikel werden direkt hinter dem
     letzten Artikel derselben Kategorie eingefügt, damit die Reihenfolge
     gruppiert bleibt ("Schlittschuhe 1–3, dann Hose 1"). */
  AsVerkaufenWizard.prototype.setzeMenge = function (kategorieId, anzahl) {
    var vorhanden = this.artikelDerKategorie(kategorieId);
    var self = this;
    if (anzahl > vorhanden.length) {
      var einfuegeIndex = this.artikel.length;
      for (var i = this.artikel.length - 1; i >= 0; i--) {
        if (this.artikel[i].kategorie === kategorieId) {
          einfuegeIndex = i + 1;
          break;
        }
      }
      var neue = [];
      for (var j = vorhanden.length; j < anzahl; j++) neue.push(this.neuerArtikel(kategorieId));
      this.artikel.splice.apply(this.artikel, [einfuegeIndex, 0].concat(neue));
    } else if (anzahl < vorhanden.length) {
      vorhanden.slice(anzahl).forEach(function (a) {
        self.artikelEntfernen(self.artikel.indexOf(a));
      });
    }
  };

  AsVerkaufenWizard.prototype.artikelEntfernen = function (index) {
    if (index < 0 || index >= this.artikel.length) return;
    var artikel = this.artikel[index];
    Object.keys(artikel.fotos || {}).forEach(function (aufgabeId) {
      (artikel.fotos[aufgabeId] || []).forEach(function (foto) {
        try {
          URL.revokeObjectURL(foto.url);
        } catch (e) {}
      });
    });
    this.artikel.splice(index, 1);
    if (this.aktuellerIndex >= this.artikel.length) this.aktuellerIndex = Math.max(0, this.artikel.length - 1);
  };

  /* "Paar 2 von 3" bzw. "Stück 2 von 3" — plus Marke/Modell, sobald bekannt,
     damit der Nutzer nie überlegen muss, welchen Artikel er gerade bearbeitet. */
  AsVerkaufenWizard.prototype.artikelBezeichnung = function (index) {
    var artikel = this.artikel[index];
    if (!artikel) return "";
    var kat = daten().kategorieFinden(artikel.kategorie);
    var gleiche = this.artikelDerKategorie(artikel.kategorie);
    var position = gleiche.indexOf(artikel) + 1;

    var name = kat.name;
    if (artikel.marke && artikel.marke !== "Weiß ich nicht" && artikel.marke !== "Andere") {
      name = artikel.marke;
      if (artikel.modell && !artikel.modellUnbekannt) name += " " + artikel.modell;
    }
    if (gleiche.length > 1) {
      name += " – " + (kat.einheit || "Stück") + " " + position + " von " + gleiche.length;
    }
    return name;
  };

  AsVerkaufenWizard.prototype.fotoanzahl = function (artikel) {
    var summe = 0;
    Object.keys(artikel.fotos || {}).forEach(function (k) {
      summe += (artikel.fotos[k] || []).length;
    });
    return summe;
  };

  /* ---------- Vollständigkeit ---------- */

  AsVerkaufenWizard.prototype.detailsVollstaendig = function (index) {
    var artikel = this.artikel[index];
    if (!artikel) return true;
    var kat = daten().kategorieFinden(artikel.kategorie);
    if (kat.spezialfall) return true;
    return kat.zustandsfragen.every(function (f) {
      return !istPflichtfrage(f) || !!artikel.antworten[f.id];
    });
  };

  /* Nur die wenigen Aufgaben, ohne die wir den Artikel weder identifizieren
     noch bepreisen können, sind Pflicht. Alles Weitere ist ausdrücklich
     optional — mehr Fotos verbessern die Einschätzung, dürfen den Verkäufer
     aber nicht ausbremsen. */
  AsVerkaufenWizard.prototype.pflichtFotoaufgaben = function (artikel, kat) {
    return this.fotoaufgabenFuer(artikel, kat).filter(function (a) {
      return !a.optional;
    });
  };

  AsVerkaufenWizard.prototype.fotosVollstaendig = function (index) {
    var artikel = this.artikel[index];
    if (!artikel) return true;
    var kat = daten().kategorieFinden(artikel.kategorie);
    return this.pflichtFotoaufgaben(artikel, kat).every(function (a) {
      return (artikel.fotos[a.id] || []).length > 0;
    });
  };

  AsVerkaufenWizard.prototype.ersterUnvollstaendigerIndex = function () {
    for (var i = 0; i < this.artikel.length; i++) {
      if (!this.detailsVollstaendig(i) || !this.fotosVollstaendig(i)) return i;
    }
    return -1;
  };

  AsVerkaufenWizard.prototype.fotoaufgabenFuer = function (artikel, kat) {
    // Ein leer gelassenes Feld zaehlt fuer die Foto-Logik genauso als
    // "unbekannt" wie ein explizites Antippen von "Weiß ich nicht" —
    // in beiden Faellen fehlt uns die Angabe, also brauchen wir das Label.
    var modellUnbekannt = artikel.modellUnbekannt || !artikel.modell;
    var groesseUnbekannt = artikel.groesseUnbekannt || !artikel.groesse;
    var aufgaben = kat.fotosStandard.slice();
    (kat.fotosBedingt || []).forEach(function (a) {
      var trifft = false;
      if (a.modellUnbekannt && modellUnbekannt && kat.brauchtModell) trifft = true;
      if (a.groesseUnbekannt && groesseUnbekannt && kat.brauchtGroesse) trifft = true;
      if (a.frage && artikel.antworten[a.frage] && a.antworten.indexOf(artikel.antworten[a.frage]) !== -1) trifft = true;
      if (trifft) aufgaben.push(a);
    });
    // Pflichtaufgaben zuerst, freiwillige immer ganz unten.
    var pflicht = aufgaben.filter(function (a) { return !a.optional; });
    var frei = aufgaben.filter(function (a) { return a.optional; });
    return pflicht.concat(frei);
  };

  /* ---------- Navigation ---------- */

  AsVerkaufenWizard.prototype.weiterVonKategorien = function () {
    if (this.artikel.length === 0) return;
    var index = this.ersterUnvollstaendigerIndex();
    this.ausZusammenfassung = false;
    if (index === -1) {
      this.schritt = "zusammenfassung";
    } else {
      this.aktuellerIndex = index;
      this.schritt = this.detailsVollstaendig(index) ? "fotos" : "details";
    }
    this.fehler = {};
    this.speichern();
    this.render();
    this.scrollNachOben();
  };

  AsVerkaufenWizard.prototype.weiterVonDetails = function () {
    var index = this.aktuellerIndex;
    var artikel = this.artikel[index];
    var kat = daten().kategorieFinden(artikel.kategorie);
    if (!kat.spezialfall) {
      var fehlt = kat.zustandsfragen.filter(function (f) {
        return istPflichtfrage(f) && !artikel.antworten[f.id];
      }).map(function (f) {
        return f.id;
      });
      if (fehlt.length > 0) {
        this.fehler = { fragen: fehlt };
        this.render();
        return;
      }
    }
    this.fehler = {};
    this.schritt = "fotos";
    this.speichern();
    this.render();
    this.scrollNachOben();
  };

  AsVerkaufenWizard.prototype.weiterVonFotos = function () {
    var index = this.aktuellerIndex;
    var artikel = this.artikel[index];
    var kat = daten().kategorieFinden(artikel.kategorie);
    var fehlt = this.pflichtFotoaufgaben(artikel, kat).filter(function (a) {
      return (artikel.fotos[a.id] || []).length === 0;
    }).map(function (a) {
      return a.id;
    });
    if (fehlt.length > 0) {
      this.fehler = { fotos: fehlt };
      this.render();
      return;
    }
    this.fehler = {};
    if (this.ausZusammenfassung || index >= this.artikel.length - 1) {
      this.ausZusammenfassung = false;
      this.schritt = "zusammenfassung";
    } else {
      this.aktuellerIndex = index + 1;
      this.schritt = "details";
    }
    this.speichern();
    this.render();
    this.scrollNachOben();
  };

  AsVerkaufenWizard.prototype.artikelBearbeiten = function (index) {
    this.aktuellerIndex = index;
    this.ausZusammenfassung = true;
    this.schritt = "details";
    this.fehler = {};
    this.render();
    this.scrollNachOben();
  };

  AsVerkaufenWizard.prototype.zurueck = function () {
    this.fehler = {};
    if (this.schritt === "details") {
      if (this.ausZusammenfassung) {
        this.ausZusammenfassung = false;
        this.schritt = "zusammenfassung";
      } else if (this.aktuellerIndex > 0) {
        this.aktuellerIndex -= 1;
        this.schritt = "fotos";
      } else {
        this.schritt = "kategorien";
      }
    } else if (this.schritt === "fotos") {
      this.schritt = "details";
    } else if (this.schritt === "zusammenfassung") {
      this.schritt = "kategorien";
    } else if (this.schritt === "fertig") {
      this.schritt = "zusammenfassung";
    }
    this.render();
    this.scrollNachOben();
  };

  AsVerkaufenWizard.prototype.scrollNachOben = function () {
    var el = this.root.closest("[data-as-verkaufen-anker]") || this.root;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  /* ---------- Fortschritt ---------- */

  AsVerkaufenWizard.prototype.fortschritt = function () {
    var anzahl = this.artikel.length;
    var gesamtSchritte = 1 + anzahl * 2 + 1;
    var aktuell = 1;
    if (this.schritt === "details") aktuell = 1 + this.aktuellerIndex * 2 + 1;
    if (this.schritt === "fotos") aktuell = 1 + this.aktuellerIndex * 2 + 2;
    if (this.schritt === "zusammenfassung") aktuell = gesamtSchritte;
    return { aktuell: aktuell, gesamt: gesamtSchritte, prozent: Math.round((aktuell / gesamtSchritte) * 100) };
  };

  AsVerkaufenWizard.prototype.renderKopf = function () {
    if (this.schritt === "fertig") return "";
    if (this.schritt === "kategorien" && this.artikel.length === 0) return "";
    var f = this.fortschritt();
    return (
      '<div class="as-verkaufen-kopf">' +
      '<div class="as-verkaufen-balken"><div class="as-verkaufen-balken-innen" style="width:' + f.prozent + '%"></div></div>' +
      '<span class="as-verkaufen-schritt-zahl">' + f.aktuell + " / " + f.gesamt + "</span>" +
      "</div>"
    );
  };

  /* Kontextzeile: sagt immer eindeutig, welcher Artikel gerade bearbeitet wird. */
  AsVerkaufenWizard.prototype.renderArtikelKontext = function () {
    if (this.artikel.length === 0) return "";
    var html = '<p class="as-verkaufen-artikel-kontext">';
    if (this.artikel.length > 1) {
      html += '<span class="as-verkaufen-artikel-zaehler">Artikel ' + (this.aktuellerIndex + 1) + " von " + this.artikel.length + "</span>";
    }
    html += "<span>" + escapeHtml(this.artikelBezeichnung(this.aktuellerIndex)) + "</span></p>";
    return html;
  };

  /* ---------- Versteckte Felder: komplette Anfrage bleibt beim
     tatsächlichen Absenden im DOM, egal welcher Bildschirm gerade sichtbar
     ist. ---------- */

  AsVerkaufenWizard.prototype.zusammenfassungText = function () {
    var self = this;
    if (this.artikel.length === 0) return "";
    var zeilen = [];
    this.artikel.forEach(function (artikel, index) {
      var kat = daten().kategorieFinden(artikel.kategorie);
      zeilen.push("--- Artikel " + (index + 1) + " von " + self.artikel.length + ": " + self.artikelBezeichnung(index) + " ---");
      zeilen.push("Kategorie: " + kat.name);
      if (kat.spezialfall) {
        if (artikel.notiz) zeilen.push("Notiz: " + artikel.notiz);
      } else {
        if (kat.marken && kat.marken.length > 0) zeilen.push("Marke: " + (artikel.marke || "weiß ich nicht"));
        if (kat.brauchtModell) zeilen.push("Modell: " + (artikel.modellUnbekannt || !artikel.modell ? "weiß ich nicht" : artikel.modell));
        if (kat.brauchtGroesse) zeilen.push((kat.groesseLabel || "Größe") + ": " + (artikel.groesseUnbekannt || !artikel.groesse ? "weiß ich nicht" : artikel.groesse));
        kat.zustandsfragen.forEach(function (f) {
          var antwort = artikel.antworten[f.id];
          if (antwort) zeilen.push(f.frage + " " + antwortLabel(f, antwort));
        });
        if (artikel.notiz) zeilen.push("Notiz: " + artikel.notiz);
      }
      zeilen.push("Fotos zu diesem Artikel: " + self.fotoanzahl(artikel));
      zeilen.push("");
    });
    zeilen.push("Fotos werden separat per E-Mail nachgereicht.");
    return zeilen.join("\n");
  };

  /* ---------- Rendering ---------- */

  AsVerkaufenWizard.prototype.render = function () {
    var html = this.renderKopf();
    html += '<div class="as-verkaufen-inhalt">';
    if (this.schritt === "kategorien") html += this.renderKategorien();
    else if (this.schritt === "details") html += this.renderDetails();
    else if (this.schritt === "fotos") html += this.renderFotos();
    else if (this.schritt === "zusammenfassung") html += this.renderZusammenfassung();
    else if (this.schritt === "fertig") html += this.renderFertig();
    html += "</div>";

    this.root.innerHTML = html;
    this.bindeEreignisse();
  };

  AsVerkaufenWizard.prototype.renderKategorien = function () {
    var self = this;
    var kategorien = daten().KATEGORIEN;

    var html = '<h1 class="as-verkaufen-frage">Was möchtest du verkaufen?</h1>';
    html += '<p class="as-verkaufen-hilfe">Wähle alles aus, was weg soll — ein einzelnes Teil reicht völlig. Bei mehreren Stücken stell die Anzahl ein, dann fragen wir jedes Teil einzeln ab.</p>';

    html += '<div class="as-verkaufen-kategorien">';
    kategorien.forEach(function (k) {
      var anzahl = self.artikelDerKategorie(k.id).length;
      var ausgewaehlt = anzahl > 0;
      html +=
        '<div class="as-verkaufen-kategorie-block' + (ausgewaehlt ? " as-verkaufen-kategorie-block-aktiv" : "") + '">' +
        '<button type="button" class="as-verkaufen-kategorie' + (ausgewaehlt ? " as-verkaufen-kategorie-aktiv" : "") + '" data-kategorie="' + k.id + '" aria-pressed="' + ausgewaehlt + '">' +
        escapeHtml(k.name) +
        (ausgewaehlt ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>' : "") +
        "</button>";
      if (ausgewaehlt) {
        var einheit = k.einheit === "Paar" ? (anzahl === 1 ? "Paar" : "Paare") : (anzahl === 1 ? "Stück" : "Stück");
        html +=
          '<div class="as-verkaufen-menge">' +
          "<span>Wie viele?</span>" +
          '<span class="as-verkaufen-stepper">' +
          '<button type="button" class="as-verkaufen-stepper-btn" data-menge-minus="' + k.id + '" aria-label="Eins weniger"' + (anzahl <= 1 ? " disabled" : "") + ">−</button>" +
          '<span class="as-verkaufen-stepper-wert" aria-live="polite">' + anzahl + " " + einheit + "</span>" +
          '<button type="button" class="as-verkaufen-stepper-btn" data-menge-plus="' + k.id + '" aria-label="Eins mehr"' + (anzahl >= MAX_MENGE ? " disabled" : "") + ">+</button>" +
          "</span></div>";
      }
      html += "</div>";
    });
    html += "</div>";

    html += '<div class="as-verkaufen-navigation">';
    html += '<span class="as-verkaufen-zurueck-platzhalter"></span>';
    html += '<div class="as-verkaufen-weiter">';
    var anzahlGesamt = this.artikel.length;
    html +=
      '<button type="button" class="btn" data-aktion="kategorien-weiter"' + (anzahlGesamt > 0 ? "" : " disabled") + ">" +
      (anzahlGesamt > 0 ? "Weiter mit " + anzahlGesamt + (anzahlGesamt === 1 ? " Teil" : " Teilen") : "Weiter") +
      "</button>";
    html += "</div></div>";
    return html;
  };

  AsVerkaufenWizard.prototype.renderDetails = function () {
    var artikel = this.artikel[this.aktuellerIndex];
    if (!artikel) return "";
    var kat = daten().kategorieFinden(artikel.kategorie);
    var self = this;

    var html = this.renderArtikelKontext();
    html += '<h1 class="as-verkaufen-frage">Kurz zu diesem Teil</h1>';

    if (kat.spezialfall) {
      html += '<p class="as-verkaufen-hilfe">' + escapeHtml(kat.hinweis) + "</p>";
      html += '<div class="as-verkaufen-feld"><label for="AsVerkaufen-notiz">Kurz beschreiben — optional</label>';
      html += '<textarea id="AsVerkaufen-notiz" data-notiz="1">' + escapeHtml(artikel.notiz) + "</textarea></div>";
      html += this.renderNavigation("details-weiter");
      return html;
    }

    html += '<p class="as-verkaufen-hilfe">Weißt du etwas nicht? Völlig in Ordnung — dann tippe einfach „Weiß ich nicht“. Wir erkennen vieles selbst auf deinen Fotos.</p>';

    if (kat.marken && kat.marken.length > 0) {
      html += '<div class="as-verkaufen-feldgruppe"><span class="as-verkaufen-feld-label">Marke</span>';
      html += '<span class="as-verkaufen-chips">';
      kat.marken.concat(["Andere", "Weiß ich nicht"]).filter(function (m, i, arr) { return arr.indexOf(m) === i; }).forEach(function (m) {
        html += '<button type="button" class="as-verkaufen-chip' + (artikel.marke === m ? " as-verkaufen-chip-aktiv" : "") + '" data-marke="' + escapeHtml(m) + '">' + escapeHtml(m) + "</button>";
      });
      html += "</span></div>";
    }

    if (kat.brauchtModell) {
      html +=
        '<div class="as-verkaufen-feld as-verkaufen-feld-mit-toggle">' +
        '<label for="AsVerkaufen-modell">Modell</label>' +
        (kat.modellHinweis ? '<span class="as-verkaufen-feld-hinweis">' + escapeHtml(kat.modellHinweis) + "</span>" : "") +
        '<input type="text" id="AsVerkaufen-modell" data-modell="1" placeholder="z. B. Vapor X3.7" value="' + escapeHtml(artikel.modell) + '"' + (artikel.modellUnbekannt ? " disabled" : "") + ">" +
        '<button type="button" class="as-verkaufen-toggle' + (artikel.modellUnbekannt ? " as-verkaufen-toggle-aktiv" : "") + '" data-toggle-unbekannt="modell">Weiß ich nicht</button>' +
        "</div>";
    }

    if (kat.brauchtGroesse) {
      html +=
        '<div class="as-verkaufen-feld as-verkaufen-feld-mit-toggle">' +
        '<label for="AsVerkaufen-groesse">' + escapeHtml(kat.groesseLabel || "Größe") + "</label>" +
        (kat.groesseHinweis ? '<span class="as-verkaufen-feld-hinweis">' + escapeHtml(kat.groesseHinweis) + "</span>" : "") +
        '<input type="text" id="AsVerkaufen-groesse" data-groesse="1" placeholder="' + escapeHtml(kat.groessePlatzhalter || "") + '" value="' + escapeHtml(artikel.groesse) + '"' + (artikel.groesseUnbekannt ? " disabled" : "") + ">" +
        '<button type="button" class="as-verkaufen-toggle' + (artikel.groesseUnbekannt ? " as-verkaufen-toggle-aktiv" : "") + '" data-toggle-unbekannt="groesse">Weiß ich nicht</button>' +
        "</div>";
    }

    html += '<h2 class="as-verkaufen-unterfrage">Noch ' + kat.zustandsfragen.length + (kat.zustandsfragen.length === 1 ? " kurze Frage" : " kurze Fragen") + "</h2>";
    kat.zustandsfragen.forEach(function (f) {
      var antwort = artikel.antworten[f.id] || "";
      var hatFehler = self.fehler.fragen && self.fehler.fragen.indexOf(f.id) !== -1;
      html += '<div class="as-verkaufen-feldgruppe' + (hatFehler ? " as-verkaufen-feldgruppe-fehler" : "") + '"><span class="as-verkaufen-feld-label">' + escapeHtml(f.frage);
      if (!istPflichtfrage(f)) html += ' <span class="as-verkaufen-freiwillig">freiwillig</span>';
      html += "</span>";
      if (f.hinweis) html += '<span class="as-verkaufen-feld-hinweis">' + escapeHtml(f.hinweis) + "</span>";
      if (f.typ === "text") {
        html += '<textarea class="as-verkaufen-freitext" rows="2" data-freitext="' + f.id + '" placeholder="' + escapeHtml(f.platzhalter || "") + '">' + escapeHtml(antwort) + "</textarea>";
      } else {
        html += '<span class="as-verkaufen-chips">';
        frageOptionen(f).forEach(function (o) {
          html += '<button type="button" class="as-verkaufen-chip' + (antwort === o.wert ? " as-verkaufen-chip-aktiv" : "") + '" data-frage="' + f.id + '" data-antwort="' + escapeHtml(o.wert) + '">' + escapeHtml(o.label) + "</button>";
        });
        html += "</span>";
      }
      if (hatFehler) html += '<p class="as-verkaufen-feld-fehler">Bitte kurz antippen — „Weiß ich nicht“ ist auch eine gültige Antwort.</p>';
      html += "</div>";
    });

    html += '<p class="notice">Normale Gebrauchsspuren sind völlig okay. Zeig uns Schäden einfach offen — so können wir dir direkt ein möglichst verlässliches Angebot machen.</p>';

    html += this.renderNavigation("details-weiter");
    return html;
  };

  AsVerkaufenWizard.prototype.renderNavigation = function (aktion, label) {
    return (
      '<div class="as-verkaufen-navigation">' +
      '<button type="button" class="as-verkaufen-zurueck" data-aktion="zurueck">Zurück</button>' +
      '<div class="as-verkaufen-weiter"><button type="button" class="btn" data-aktion="' + aktion + '">' + (label || "Weiter") + "</button></div>" +
      "</div>"
    );
  };

  AsVerkaufenWizard.prototype.renderFotos = function () {
    var self = this;
    var artikel = this.artikel[this.aktuellerIndex];
    if (!artikel) return "";
    var kat = daten().kategorieFinden(artikel.kategorie);
    var aufgaben = this.fotoaufgabenFuer(artikel, kat);
    var anzahlPflicht = this.pflichtFotoaufgaben(artikel, kat).length;

    var html = this.renderArtikelKontext();
    html += '<h1 class="as-verkaufen-frage">Fotos von diesem Teil</h1>';
    html +=
      '<p class="as-verkaufen-hilfe">Handyfotos reichen völlig. Nur ' +
      anzahlPflicht +
      (anzahlPflicht === 1 ? " Foto ist" : " Fotos sind") +
      " nötig — alles Weitere ist freiwillig und hilft uns nur, den Preis genauer zu treffen.</p>";

    html += '<div class="as-verkaufen-fotoaufgaben">';
    aufgaben.forEach(function (aufgabe) {
      var vorhandene = artikel.fotos[aufgabe.id] || [];
      var hatFehler = self.fehler.fotos && self.fehler.fotos.indexOf(aufgabe.id) !== -1;
      html += '<div class="as-verkaufen-fotoaufgabe' + (hatFehler ? " as-verkaufen-fotoaufgabe-fehler" : "") + (vorhandene.length > 0 ? " as-verkaufen-fotoaufgabe-fertig" : "") + (aufgabe.optional ? " as-verkaufen-fotoaufgabe-freiwillig" : "") + '">';
      html += '<div class="as-verkaufen-fotoaufgabe-kopf"><span class="as-verkaufen-fotoaufgabe-titel">' + escapeHtml(aufgabe.titel) + (aufgabe.optional ? ' <span class="as-verkaufen-freiwillig">freiwillig</span>' : "") + "</span>";
      html += '<span class="as-verkaufen-fotoaufgabe-anleitung">' + escapeHtml(aufgabe.was || aufgabe.anleitung || "") + "</span>";
      if (aufgabe.warum) html += '<span class="as-verkaufen-fotoaufgabe-warum">' + escapeHtml(aufgabe.warum) + "</span>";
      html += "</div>";

      if (vorhandene.length > 0) {
        html += '<div class="as-verkaufen-fotos-vorschau">';
        vorhandene.forEach(function (foto, index) {
          html +=
            '<span class="as-verkaufen-foto-thumb"><img src="' + foto.url + '" alt=""><button type="button" class="as-verkaufen-foto-entfernen" data-foto-entfernen="' + aufgabe.id + '" data-foto-index="' + index + '" aria-label="Foto entfernen">×</button></span>';
        });
        html += "</div>";
      }

      html += '<div class="as-verkaufen-foto-aktionen">';
      html +=
        '<label class="as-verkaufen-foto-btn">' + (vorhandene.length > 0 ? "Noch ein Foto" : "Foto aufnehmen") + '<input type="file" accept="image/*" capture="environment" data-foto-eingabe="' + aufgabe.id + '" hidden></label>';
      html +=
        '<label class="as-verkaufen-foto-btn as-verkaufen-foto-btn-sekundaer">Aus Mediathek wählen<input type="file" accept="image/*" multiple data-foto-eingabe="' + aufgabe.id + '" hidden></label>';
      html += "</div>";
      if (hatFehler) html += '<p class="as-verkaufen-feld-fehler">Dieses Foto fehlt noch.</p>';
      html += "</div>";
    });
    html += "</div>";

    html += this.renderNavigation("fotos-weiter");
    return html;
  };

  AsVerkaufenWizard.prototype.renderZusammenfassung = function () {
    var self = this;
    var html = '<h1 class="as-verkaufen-frage">Passt das so?</h1>';
    html += '<p class="as-verkaufen-hilfe">Prüf kurz deine ' + this.artikel.length + (this.artikel.length === 1 ? " Angabe" : " Teile") + ". Du kannst jedes Teil einzeln ändern, ohne von vorne anzufangen.</p>";

    html += '<ul class="as-verkaufen-zusammenfassung" role="list">';
    this.artikel.forEach(function (artikel, index) {
      var kat = daten().kategorieFinden(artikel.kategorie);
      var meta = [];
      if (!kat.spezialfall) {
        if (kat.brauchtGroesse) meta.push((kat.groesseLabel || "Größe") + ": " + (artikel.groesseUnbekannt || !artikel.groesse ? "weiß ich nicht" : artikel.groesse));
        if (kat.marken && kat.marken.length > 0 && artikel.marke) meta.push(artikel.marke);
      }
      var anzahlFotos = self.fotoanzahl(artikel);
      meta.push(anzahlFotos + (anzahlFotos === 1 ? " Foto" : " Fotos"));

      html += '<li class="as-verkaufen-zusammenfassung-eintrag">';
      html += '<span class="as-verkaufen-zusammenfassung-nummer">' + (index + 1) + "</span>";
      html += '<span class="as-verkaufen-zusammenfassung-text">';
      html += '<span class="as-verkaufen-zusammenfassung-titel">' + escapeHtml(self.artikelBezeichnung(index)) + "</span>";
      html += '<span class="as-verkaufen-zusammenfassung-meta">' + escapeHtml(kat.name + " · " + meta.join(" · ")) + "</span>";
      html += "</span>";
      html += '<span class="as-verkaufen-zusammenfassung-aktionen">';
      html += '<button type="button" class="as-verkaufen-zusammenfassung-bearbeiten" data-bearbeiten="' + index + '">Bearbeiten</button>';
      html += '<button type="button" class="as-verkaufen-zusammenfassung-loeschen" data-loeschen="' + index + '" aria-label="Artikel entfernen">Entfernen</button>';
      html += "</span>";
      html += "</li>";
    });
    html += "</ul>";

    html += '<button type="button" class="as-verkaufen-artikel-hinzufuegen" data-aktion="mehr-hinzufuegen">+ Weiteres Teil hinzufügen</button>';

    var fotosGesamt = this.artikel.reduce(function (summe, a) {
      return summe + self.fotoanzahl(a);
    }, 0);

    html += '<div class="as-verkaufen-absenden">';
    html += '<p class="as-verkaufen-absenden-text">Zum Schluss schickst du uns alles in einer Mail — ' +
      fotosGesamt + (fotosGesamt === 1 ? " Foto" : " Fotos") +
      ' als eine Datei angehängt, dein Text ist schon fertig. Wir antworten dir einfach auf diese Mail.</p>';
    html += this.renderMailEmpfaenger();
    html += '<p class="as-verkaufen-feld-hinweis">Beim Tippen auf „Jetzt per Mail senden“ kopieren wir die Adresse automatisch — im Empfängerfeld deiner Mail genügt dann Einfügen.</p>';
    html += '<div class="as-verkaufen-absenden-aktionen">';
    html += '<button type="button" class="btn" data-aktion="per-mail-senden">Jetzt per Mail senden</button>';
    html += '<button type="button" class="btn-sekundaer" data-aktion="paket-laden">Fotos herunterladen</button>';
    html += "</div>";
    html += '<p class="as-verkaufen-absenden-status" data-absenden-status></p>';
    html += "</div>";

    html +=
      '<div class="as-verkaufen-navigation">' +
      '<button type="button" class="as-verkaufen-zurueck" data-aktion="zurueck">Zurück</button>' +
      "</div>";
    return html;
  };

  /* ---------- Abschluss: alles in einer Mail ----------
     Der Kunde gibt bewusst keine E-Mail-Adresse mehr ein. Er schreibt uns
     aus seinem eigenen Postfach, damit haben wir seine Adresse automatisch
     und können einfach antworten.

     Warum der Teilen-Dialog und kein reiner mailto-Link: `mailto:` kann
     prinzipbedingt KEINE Dateien anhängen (sonst könnte jede Website
     ungefragt Dateien verschicken). Der native Teilen-Dialog kann es —
     dort öffnet sich die Mail-App mit angehängter Zip-Datei und
     vorbereitetem Text. Fehlt er (viele Desktop-Browser), wird die
     Zip-Datei heruntergeladen UND die Mail mit fertigem Text geöffnet;
     dann bleibt nur das Anhängen der einen Datei von Hand. */

  AsVerkaufenWizard.prototype.mailAdresse = function () {
    return this.root.getAttribute("data-mail-adresse") || "";
  };

  AsVerkaufenWizard.prototype.mailBetreff = function () {
    return this.root.getAttribute("data-mail-betreff") || "Ankauf-Anfrage";
  };

  /* Der Teilen-Dialog kann Empfänger und Betreff technisch NICHT vorbelegen
     — die Web-Share-Schnittstelle kennt beides nicht. Damit der Kunde nicht
     rätselt, wohin die Mail soll, stehen beide als erste Zeilen im Text und
     zusätzlich sichtbar über dem Knopf. */
  AsVerkaufenWizard.prototype.mailText = function () {
    var kopf = this.root.getAttribute("data-mail-einleitung") || "Hallo AthleteSwap-Team,";
    var zeilen = [
      "An: " + this.mailAdresse(),
      "Betreff: " + this.mailBetreff(),
      "",
      kopf,
      "",
      "ich möchte folgende Ausrüstung verkaufen:",
      "",
      this.zusammenfassungText(),
      "Die Fotos liegen als Zip-Datei bei."
    ];
    return zeilen.join("\n");
  };

  AsVerkaufenWizard.prototype.statusSetzen = function (text) {
    var feld = this.root.querySelector("[data-absenden-status]");
    if (feld) feld.textContent = text || "";
  };

  /* Sammelt alle Fotos aller Artikel und packt sie in EINE Zip-Datei. */
  AsVerkaufenWizard.prototype.paketErstellen = function (fertig) {
    var self = this;
    var eintraege = [];
    this.artikel.forEach(function (artikel, index) {
      var kat = daten().kategorieFinden(artikel.kategorie);
      var aufgaben = self.fotoaufgabenFuer(artikel, kat);
      Object.keys(artikel.fotos || {}).forEach(function (aufgabeId) {
        var aufgabe = aufgaben.filter(function (a) { return a.id === aufgabeId; })[0];
        (artikel.fotos[aufgabeId] || []).forEach(function (foto, n) {
          eintraege.push({
            name: "Artikel-" + (index + 1) + "_" + dateiName(aufgabe ? aufgabe.titel : aufgabeId) + "-" + (n + 1) + dateiEndung(foto.file),
            blob: foto.file
          });
        });
      });
    });
    if (eintraege.length === 0) return fertig(null);

    blobsLesen(eintraege, function (gelesene) {
      var name = "AthleteSwap-Fotos-" + new Date().toISOString().slice(0, 10) + ".zip";
      try {
        var blob = zipBauen(gelesene);
        try {
          fertig(new File([blob], name, { type: "application/zip" }));
        } catch (e) {
          blob.name = name;
          fertig(blob);
        }
      } catch (e) {
        fertig(null);
      }
    });
  };

  AsVerkaufenWizard.prototype.paketSpeichern = function (paket) {
    var url = URL.createObjectURL(paket);
    var a = document.createElement("a");
    a.href = url;
    a.download = paket.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
  };

  AsVerkaufenWizard.prototype.mailOeffnen = function (mitHinweis) {
    var adresse = this.mailAdresse();
    var betreff = this.mailBetreff();
    var koerper = this.mailText();
    // Sehr lange mailto-Adressen werden von manchen Programmen abgeschnitten.
    if (koerper.length > 1800) koerper = koerper.slice(0, 1800) + "\n[gekürzt]";
    window.location.href =
      "mailto:" + encodeURIComponent(adresse) +
      "?subject=" + encodeURIComponent(betreff) +
      "&body=" + encodeURIComponent(koerper);
    if (mitHinweis) {
      this.statusSetzen("Deine Mail wurde geöffnet. Häng jetzt bitte noch die heruntergeladene Zip-Datei an — darin liegen alle Fotos nach Artikel benannt.");
    }
  };

  /* Die Web-Share-Schnittstelle kennt laut Spezifikation nur files, title,
     text und url — einen Empfänger gibt es dort nicht. Damit der Kunde die
     Adresse nicht abtippen muss, wandert sie beim Tippen sofort in die
     Zwischenablage; im Empfängerfeld genügt dann Einfügen. Das muss direkt
     im Klick passieren, weil Browser den Zugriff auf die Zwischenablage nur
     innerhalb einer echten Nutzeraktion erlauben. */
  AsVerkaufenWizard.prototype.adresseKopieren = function () {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(this.mailAdresse()).then(function () {
          return true;
        })["catch"](function () {
          return false;
        });
      }
    } catch (e) {}
    return null;
  };

  AsVerkaufenWizard.prototype.perMailSenden = function (knopf) {
    var self = this;
    var kopieren = this.adresseKopieren();
    var adresseKopiert = false;
    if (kopieren) kopieren.then(function (ok) { adresseKopiert = ok; });

    if (knopf) knopf.disabled = true;
    this.statusSetzen("Deine Fotos werden zu einer Datei gebündelt …");
    this.paketErstellen(function (paket) {
      if (knopf) knopf.disabled = false;
      var text = self.mailText();
      var kannTeilen = !!(paket && navigator.canShare && navigator.canShare({ files: [paket] }));
      var ueberDownload = function () {
        // Rückfallebene: Datei speichern UND Mail mit Empfänger, Betreff und
        // fertigem Text öffnen. Angehängt werden muss dann nur die eine Datei.
        if (paket) self.paketSpeichern(paket);
        self.mailOeffnen(!!paket);
        if (!paket) self.statusSetzen("Deine Mail wurde geöffnet.");
      };

      if (kannTeilen) {
        navigator.share({
          files: [paket],
          title: self.mailBetreff(),
          text: text
        }).then(function () {
          self.abgeschickt(adresseKopiert);
        })["catch"](function (fehler) {
          // Bewusster Abbruch durch den Nutzer: nichts tun, er kann erneut
          // tippen. Alles andere ist ein echter Fehler — dann sofort die
          // Rückfallebene, statt den Kunden in einer Sackgasse zu lassen.
          if (fehler && fehler.name === "AbortError") {
            self.statusSetzen("");
            return;
          }
          ueberDownload();
        });
        return;
      }
      ueberDownload();
    });
  };

  AsVerkaufenWizard.prototype.paketHerunterladen = function (knopf) {
    var self = this;
    if (knopf) knopf.disabled = true;
    this.statusSetzen("Deine Fotos werden zu einer Datei gebündelt …");
    this.paketErstellen(function (paket) {
      if (knopf) knopf.disabled = false;
      if (!paket) return self.statusSetzen("Es sind noch keine Fotos vorhanden.");
      self.paketSpeichern(paket);
      self.statusSetzen("Gespeichert. Häng die Datei einfach an eine Mail an uns an.");
    });
  };

  AsVerkaufenWizard.prototype.abgeschickt = function (adresseKopiert) {
    /* Bewusst ohne Löschen der Angaben: Der Kunde muss die Mail in seinem
       Programm noch abschicken. Solange das nicht sicher ist, bleiben seine
       Eingaben erhalten, damit er es wiederholen kann. */
    this.adresseKopiert = !!adresseKopiert;
    this.schritt = "fertig";
    this.render();
    this.scrollNachOben();
  };

  /* Empfänger und Betreff zum Ablesen und Kopieren — der Teilen-Dialog kann
     beides nicht vorbelegen, also muss es sichtbar sein. */
  AsVerkaufenWizard.prototype.renderMailEmpfaenger = function () {
    return (
      '<dl class="as-verkaufen-mailkopf">' +
      "<div><dt>Empfänger</dt><dd>" +
      '<span class="as-verkaufen-mailkopf-wert">' + escapeHtml(this.mailAdresse()) + "</span>" +
      '<button type="button" class="as-verkaufen-kopieren" data-kopieren="' + escapeHtml(this.mailAdresse()) + '">Adresse kopieren</button>' +
      "</dd></div>" +
      "<div><dt>Betreff</dt><dd><span class=\"as-verkaufen-mailkopf-wert\">" + escapeHtml(this.mailBetreff()) + "</span></dd></div>" +
      "</dl>" +
      '<p class="as-verkaufen-feld-hinweis">Beides steht auch oben in der fertigen Nachricht, falls deine Mail-App es nicht automatisch übernimmt.</p>'
    );
  };

  AsVerkaufenWizard.prototype.renderFertig = function () {
    return (
      '<h1 class="as-verkaufen-frage">Fast geschafft.</h1>' +
      '<p class="as-verkaufen-hilfe">Deine Mail ist vorbereitet — trag oben noch den Empfänger ein' +
      (this.adresseKopiert ? " (die Adresse liegt schon in deiner Zwischenablage, einfach einfügen)" : "") +
      " und schick sie ab. Sobald sie bei uns ist, schauen wir uns die Fotos an und melden uns mit einem Angebot.</p>" +
      this.renderMailEmpfaenger() +
      '<p class="as-verkaufen-hilfe">Hat etwas nicht geklappt? Du kannst es direkt noch einmal versuchen — deine Angaben und Fotos sind noch da.</p>' +
      '<div class="as-verkaufen-absenden-aktionen">' +
      '<button type="button" class="btn" data-aktion="per-mail-senden">Noch einmal senden</button>' +
      '<button type="button" class="btn-sekundaer" data-aktion="paket-laden">Fotos herunterladen</button>' +
      "</div>" +
      '<p class="as-verkaufen-absenden-status" data-absenden-status></p>' +
      '<div class="as-verkaufen-navigation">' +
      '<button type="button" class="as-verkaufen-zurueck" data-aktion="zurueck">Zurück zur Übersicht</button>' +
      "</div>"
    );
  };

  /* ---------- Ereignisse ---------- */

  AsVerkaufenWizard.prototype.aktuellerArtikel = function () {
    return this.artikel[this.aktuellerIndex];
  };

  AsVerkaufenWizard.prototype.bindeEreignisse = function () {
    var self = this;

    this.root.querySelectorAll("[data-kategorie]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-kategorie");
        var anzahl = self.artikelDerKategorie(id).length;
        self.setzeMenge(id, anzahl > 0 ? 0 : 1);
        self.speichern();
        self.render();
      });
    });

    this.root.querySelectorAll("[data-menge-plus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-menge-plus");
        self.setzeMenge(id, Math.min(MAX_MENGE, self.artikelDerKategorie(id).length + 1));
        self.speichern();
        self.render();
      });
    });

    this.root.querySelectorAll("[data-menge-minus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-menge-minus");
        self.setzeMenge(id, Math.max(1, self.artikelDerKategorie(id).length - 1));
        self.speichern();
        self.render();
      });
    });

    var kategorienWeiter = this.root.querySelector('[data-aktion="kategorien-weiter"]');
    if (kategorienWeiter) kategorienWeiter.addEventListener("click", function () { self.weiterVonKategorien(); });

    this.root.querySelectorAll("[data-marke]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.aktuellerArtikel().marke = btn.getAttribute("data-marke");
        self.speichern();
        self.render();
      });
    });

    this.root.querySelectorAll("[data-modell]").forEach(function (input) {
      input.addEventListener("input", function () {
        self.aktuellerArtikel().modell = input.value;
      });
    });
    this.root.querySelectorAll("[data-groesse]").forEach(function (input) {
      input.addEventListener("input", function () {
        self.aktuellerArtikel().groesse = input.value;
      });
    });
    this.root.querySelectorAll("[data-freitext]").forEach(function (feld) {
      feld.addEventListener("input", function () {
        self.aktuellerArtikel().antworten[feld.getAttribute("data-freitext")] = feld.value;
      });
    });
    this.root.querySelectorAll("[data-notiz]").forEach(function (input) {
      input.addEventListener("input", function () {
        self.aktuellerArtikel().notiz = input.value;
      });
    });

    this.root.querySelectorAll("[data-toggle-unbekannt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var feld = btn.getAttribute("data-toggle-unbekannt");
        var artikel = self.aktuellerArtikel();
        if (feld === "modell") artikel.modellUnbekannt = !artikel.modellUnbekannt;
        if (feld === "groesse") artikel.groesseUnbekannt = !artikel.groesseUnbekannt;
        self.speichern();
        self.render();
      });
    });

    this.root.querySelectorAll("[data-frage]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.aktuellerArtikel().antworten[btn.getAttribute("data-frage")] = btn.getAttribute("data-antwort");
        self.speichern();
        self.render();
      });
    });

    var detailsWeiter = this.root.querySelector('[data-aktion="details-weiter"]');
    if (detailsWeiter) detailsWeiter.addEventListener("click", function () { self.weiterVonDetails(); });

    this.root.querySelectorAll("[data-foto-eingabe]").forEach(function (input) {
      input.addEventListener("change", function () {
        var aufgabeId = input.getAttribute("data-foto-eingabe");
        var artikel = self.aktuellerArtikel();
        if (!artikel.fotos[aufgabeId]) artikel.fotos[aufgabeId] = [];
        var dateien = Array.prototype.slice.call(input.files);
        if (dateien.length === 0) return;
        var offen = dateien.length;
        dateien.forEach(function (datei) {
          bildVerkleinern(datei, function (fertigeDatei) {
            artikel.fotos[aufgabeId].push({ file: fertigeDatei, url: URL.createObjectURL(fertigeDatei) });
            offen -= 1;
            if (offen === 0) self.render();
          });
        });
      });
    });

    this.root.querySelectorAll("[data-foto-entfernen]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var artikel = self.aktuellerArtikel();
        var aufgabeId = btn.getAttribute("data-foto-entfernen");
        var index = parseInt(btn.getAttribute("data-foto-index"), 10);
        if (artikel.fotos[aufgabeId] && artikel.fotos[aufgabeId][index]) {
          try {
            URL.revokeObjectURL(artikel.fotos[aufgabeId][index].url);
          } catch (e) {}
          artikel.fotos[aufgabeId].splice(index, 1);
        }
        self.render();
      });
    });

    var fotosWeiter = this.root.querySelector('[data-aktion="fotos-weiter"]');
    if (fotosWeiter) fotosWeiter.addEventListener("click", function () { self.weiterVonFotos(); });

    this.root.querySelectorAll("[data-bearbeiten]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.artikelBearbeiten(parseInt(btn.getAttribute("data-bearbeiten"), 10));
      });
    });

    this.root.querySelectorAll("[data-loeschen]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.artikelEntfernen(parseInt(btn.getAttribute("data-loeschen"), 10));
        if (self.artikel.length === 0) self.schritt = "kategorien";
        self.speichern();
        self.render();
      });
    });

    var mehrHinzufuegen = this.root.querySelector('[data-aktion="mehr-hinzufuegen"]');
    if (mehrHinzufuegen) mehrHinzufuegen.addEventListener("click", function () {
      self.schritt = "kategorien";
      self.ausZusammenfassung = false;
      self.render();
      self.scrollNachOben();
    });

    var mailBtn = this.root.querySelector('[data-aktion="per-mail-senden"]');
    if (mailBtn) mailBtn.addEventListener("click", function () { self.perMailSenden(mailBtn); });

    var ladenBtn = this.root.querySelector('[data-aktion="paket-laden"]');
    if (ladenBtn) ladenBtn.addEventListener("click", function () { self.paketHerunterladen(ladenBtn); });

    this.root.querySelectorAll("[data-kopieren]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var wert = btn.getAttribute("data-kopieren");
        var fertig = function () {
          btn.textContent = "Kopiert";
          window.setTimeout(function () { btn.textContent = "Kopieren"; }, 2000);
        };
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(wert).then(fertig)["catch"](function () {});
            return;
          }
        } catch (e) {}
        fertig();
      });
    });

    var zurueckBtn = this.root.querySelector('[data-aktion="zurueck"]');
    if (zurueckBtn) zurueckBtn.addEventListener("click", function () { self.zurueck(); });

  };

  /* ---------- Fotoübergabe: sichern vor dem Absenden ---------- */

  function dateiEndung(datei) {
    var typ = (datei && datei.type) || "";
    if (typ.indexOf("png") !== -1) return ".png";
    if (typ.indexOf("webp") !== -1) return ".webp";
    if (typ.indexOf("heic") !== -1) return ".heic";
    return ".jpg";
  }

  function dateiName(text) {
    return String(text || "Foto")
      .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue")
      .replace(/Ä/g, "Ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue").replace(/ß/g, "ss")
      .replace(/[^a-zA-Z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40);
  }

  /* Handyfotos sind roh 3–5 MB gross; 20 Stueck sprengen jedes Upload-Limit
     und jeden Mailanhang. Fuer die Zustandsbeurteilung genuegt die lange
     Kante in 1800 px bei weitem, das ergibt rund 250 KB je Bild. Verkleinert
     wird im Browser, bevor das Foto irgendwo landet — schlaegt etwas fehl
     (unbekanntes Format, Speicher), wird still das Original behalten. */
  var FOTO_MAX_KANTE = 1800;
  var FOTO_QUALITAET = 0.82;
  var FOTO_KLEIN_GENUG = 500000;

  function bildVerkleinern(datei, fertig) {
    try {
      if (!datei || !datei.type || datei.type.indexOf("image/") !== 0) return fertig(datei);
      if (!window.HTMLCanvasElement || !document.createElement("canvas").toBlob) return fertig(datei);
      var quelle = URL.createObjectURL(datei);
      var bild = new Image();
      bild.onload = function () {
        try {
          var breite = bild.naturalWidth || bild.width;
          var hoehe = bild.naturalHeight || bild.height;
          if (!breite || !hoehe) { URL.revokeObjectURL(quelle); return fertig(datei); }
          var faktor = Math.min(1, FOTO_MAX_KANTE / Math.max(breite, hoehe));
          if (faktor >= 1 && datei.size <= FOTO_KLEIN_GENUG) {
            URL.revokeObjectURL(quelle);
            return fertig(datei);
          }
          var zielBreite = Math.round(breite * faktor);
          var zielHoehe = Math.round(hoehe * faktor);
          var flaeche = document.createElement("canvas");
          flaeche.width = zielBreite;
          flaeche.height = zielHoehe;
          flaeche.getContext("2d").drawImage(bild, 0, 0, zielBreite, zielHoehe);
          flaeche.toBlob(function (blob) {
            URL.revokeObjectURL(quelle);
            if (!blob || blob.size >= datei.size) return fertig(datei);
            var name = String(datei.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
            try {
              fertig(new File([blob], name, { type: "image/jpeg" }));
            } catch (e) {
              blob.name = name;
              fertig(blob);
            }
          }, "image/jpeg", FOTO_QUALITAET);
        } catch (e) {
          URL.revokeObjectURL(quelle);
          fertig(datei);
        }
      };
      bild.onerror = function () {
        URL.revokeObjectURL(quelle);
        fertig(datei);
      };
      bild.src = quelle;
    } catch (e) {
      fertig(datei);
    }
  }

  /* ---------- ZIP-Packer ----------
     Bewusst ohne Fremdbibliothek: Fotos sind bereits JPEG-komprimiert, eine
     zweite Kompression bringt praktisch nichts. Deshalb genügt die
     ZIP-Methode "gespeichert" (STORE), die sich in wenigen Zeilen selbst
     schreiben lässt — kein zusätzliches Asset, kein CDN. */
  var CRC_TABELLE = (function () {
    var tabelle = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
      tabelle[n] = c >>> 0;
    }
    return tabelle;
  })();

  function crc32(daten) {
    var c = 0xffffffff;
    for (var i = 0; i < daten.length; i++) c = CRC_TABELLE[(c ^ daten[i]) & 0xff] ^ (c >>> 8);
    return (c ^ 0xffffffff) >>> 0;
  }

  function textZuBytes(text) {
    if (window.TextEncoder) return new TextEncoder().encode(text);
    var bytes = [];
    for (var i = 0; i < text.length; i++) {
      var z = text.charCodeAt(i);
      if (z < 128) bytes.push(z);
      else if (z < 2048) bytes.push(192 | (z >> 6), 128 | (z & 63));
      else bytes.push(224 | (z >> 12), 128 | ((z >> 6) & 63), 128 | (z & 63));
    }
    return new Uint8Array(bytes);
  }

  function zipZeitstempel(datum) {
    return {
      zeit: ((datum.getHours() << 11) | (datum.getMinutes() << 5) | Math.floor(datum.getSeconds() / 2)) & 0xffff,
      datum: (((datum.getFullYear() - 1980) << 9) | ((datum.getMonth() + 1) << 5) | datum.getDate()) & 0xffff
    };
  }

  function zipBauen(dateien) {
    var teile = [];
    var zentral = [];
    var versatz = 0;
    var stempel = zipZeitstempel(new Date());

    dateien.forEach(function (datei) {
      var name = textZuBytes(datei.name);
      var pruefsumme = crc32(datei.daten);
      var groesse = datei.daten.length;

      var lokal = new Uint8Array(30 + name.length);
      var ls = new DataView(lokal.buffer);
      ls.setUint32(0, 0x04034b50, true);
      ls.setUint16(4, 20, true);
      ls.setUint16(6, 0x0800, true);
      ls.setUint16(8, 0, true);
      ls.setUint16(10, stempel.zeit, true);
      ls.setUint16(12, stempel.datum, true);
      ls.setUint32(14, pruefsumme, true);
      ls.setUint32(18, groesse, true);
      ls.setUint32(22, groesse, true);
      ls.setUint16(26, name.length, true);
      ls.setUint16(28, 0, true);
      lokal.set(name, 30);
      teile.push(lokal, datei.daten);

      var eintrag = new Uint8Array(46 + name.length);
      var zs = new DataView(eintrag.buffer);
      zs.setUint32(0, 0x02014b50, true);
      zs.setUint16(4, 20, true);
      zs.setUint16(6, 20, true);
      zs.setUint16(8, 0x0800, true);
      zs.setUint16(10, 0, true);
      zs.setUint16(12, stempel.zeit, true);
      zs.setUint16(14, stempel.datum, true);
      zs.setUint32(16, pruefsumme, true);
      zs.setUint32(20, groesse, true);
      zs.setUint32(24, groesse, true);
      zs.setUint16(28, name.length, true);
      zs.setUint16(30, 0, true);
      zs.setUint16(32, 0, true);
      zs.setUint16(34, 0, true);
      zs.setUint16(36, 0, true);
      zs.setUint32(38, 0, true);
      zs.setUint32(42, versatz, true);
      eintrag.set(name, 46);
      zentral.push(eintrag);

      versatz += lokal.length + groesse;
    });

    var zentralGroesse = zentral.reduce(function (summe, e) { return summe + e.length; }, 0);
    var ende = new Uint8Array(22);
    var es = new DataView(ende.buffer);
    es.setUint32(0, 0x06054b50, true);
    es.setUint16(4, 0, true);
    es.setUint16(6, 0, true);
    es.setUint16(8, dateien.length, true);
    es.setUint16(10, dateien.length, true);
    es.setUint32(12, zentralGroesse, true);
    es.setUint32(16, versatz, true);
    es.setUint16(20, 0, true);

    return new Blob(teile.concat(zentral, [ende]), { type: "application/zip" });
  }

  function blobsLesen(eintraege, fertig) {
    var ergebnis = [];
    var offen = eintraege.length;
    if (offen === 0) return fertig([]);
    eintraege.forEach(function (eintrag, i) {
      var uebernehmen = function (puffer) {
        ergebnis[i] = { name: eintrag.name, daten: new Uint8Array(puffer || new ArrayBuffer(0)) };
        offen -= 1;
        if (offen === 0) fertig(ergebnis);
      };
      try {
        if (eintrag.blob.arrayBuffer) {
          eintrag.blob.arrayBuffer().then(uebernehmen)["catch"](function () { uebernehmen(null); });
        } else {
          var leser = new FileReader();
          leser.onload = function () { uebernehmen(leser.result); };
          leser.onerror = function () { uebernehmen(null); };
          leser.readAsArrayBuffer(eintrag.blob);
        }
      } catch (e) {
        uebernehmen(null);
      }
    });
  }
  function init() {
    document.querySelectorAll("[data-as-verkaufen-wizard]:not([data-as-verkaufen-wizard-init])").forEach(function (root) {
      root.setAttribute("data-as-verkaufen-wizard-init", "");
      new AsVerkaufenWizard(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
